// extracted by mini-css-extract-plugin
export var icon = "search-module--icon--8f021 h-ms1 w-auto";